var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pho-multilingual-radio"},[_c('PhoRadio',{attrs:{"items":_vm.translatedItems,"title":_vm.title,"mandatory":_vm.mandatory,"disabled":_vm.disabled,"row":_vm.row},model:{value:(_vm.lazyValue),callback:function ($$v) {_vm.lazyValue=$$v},expression:"lazyValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }